(function () {
  function interpretMusicQuery(input) {
    var text = String(input || '');
    if (/\b(?:grade\s*\d+(?:\.\d+)?\s*(?:-|to|or)\s*\d|\d+\s*(?:-|to|or)\s*\d+\s*percussion)/i.test(text)) return null;
    var gradeMatch = /\bgrade\s*:?\s*(\d+(?:\.\d+)?)\b/i.exec(text);
    var percussionMatch = /\b(?:(up\s+to|at\s+most|no\s+more\s+than|maximum(?:\s+of)?)\s+)?(\d+)\s+percussion(?:ists?|\s+(?:players?|people))\b/i.exec(text);
    if (!gradeMatch && !percussionMatch) return null;
    var grade = gradeMatch ? Number(gradeMatch[1]) : null;
    var percussion = percussionMatch ? Number(percussionMatch[2]) : null;
    if (grade !== null && (grade < 0 || grade > 6)) return null;
    if (percussion !== null && (percussion < 1 || percussion > 30)) return null;
    var rest = text;
    if (gradeMatch) rest = rest.replace(gradeMatch[0], ' ');
    if (percussionMatch) rest = rest.replace(percussionMatch[0], ' ');
    rest = rest.replace(/[,;]+/g, ' ').replace(/\s+/g, ' ').trim();
    rest = rest.replace(/^(?:(?:and|with|for)\s+)+|(?:\s+(?:and|with|for))+$/gi, '').trim();
    if (/^(?:and|with|for)$/i.test(rest)) rest = '';
    return {grade: grade, percussion: percussion, maximum: !!(percussionMatch && percussionMatch[1]), rest: rest};
  }
  function buildMusicURL(selection, origin, preview) {
    var collectionPath = /^\/collections\/[a-z0-9-]+$/.test(selection.collectionPath || '') ? selection.collectionPath : '/collections/all-music';
    if (!selection.rest && /^(slow|medium|fast|mixed)$/.test(selection.tempo || '')) collectionPath += '/tempo-' + selection.tempo;
    var target = new URL(selection.rest ? '/search' : collectionPath, origin);
    if (selection.rest) {
      target.searchParams.set('q', selection.rest);
      target.searchParams.set('type', 'product');
    }
    if (selection.grade !== null && selection.grade !== '') target.searchParams.set('filter.p.m.custom.grade_level', 'Grade ' + Number(selection.grade));
    if (selection.percussion !== null && selection.percussion !== '') {
      var count = Number(selection.percussion);
      for (var n = selection.maximum ? 1 : count; n <= count; n++) target.searchParams.append('filter.p.m.custom.number_of_percussionists', n + (n === 1 ? ' percussionist' : ' percussionists'));
    }
    if (preview) target.searchParams.set('preview_theme_id', preview);
    return target;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {interpretMusicQuery: interpretMusicQuery, buildMusicURL: buildMusicURL};
  if (typeof document === 'undefined') return;
  function removeDuplicateDetails() {
    if (!document.querySelector('.gm-performance')) return;
    document.querySelectorAll('section[aria-label="Performance details"]').forEach(function (section) {
      var heading = section.querySelector('h2');
      if (!heading || heading.textContent.trim() !== 'At a glance') return;
      var list = heading.nextElementSibling;
      if (list && list.tagName === 'UL') list.remove();
      heading.remove();
    });
  }
  function initializeMusicControls() {
    var params = new URL(window.location.href).searchParams;
    var grade = (params.get('filter.p.m.custom.grade_level') || '').replace(/^Grade\s+/i, '');
    var counts = params.getAll('filter.p.m.custom.number_of_percussionists').map(function (value) { return parseInt(value, 10); }).filter(Number.isFinite);
    document.querySelectorAll('[data-gm-music-filters]').forEach(function (form) {
      form.elements.gm_grade.value = grade;
      form.elements.gm_percussion_choice.value = counts.length ? (counts.length === 1 ? 'exact:' : 'max:') + Math.max.apply(null, counts) : '';
      var tempo = /\/tempo-(slow|medium|fast|mixed)\/?$/.exec(window.location.pathname);
      form.elements.gm_tempo.value = tempo ? tempo[1] : '';
    });
    removeDuplicateDetails();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMusicControls);
  else initializeMusicControls();
  window.addEventListener('popstate', initializeMusicControls);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var selection;
    if (form.matches('[data-gm-music-filters]')) {
      var percussionChoice = /^(max|exact):(\d+)$/.exec(form.elements.gm_percussion_choice.value);
      selection = {grade: form.elements.gm_grade.value, percussion: percussionChoice ? percussionChoice[2] : '', maximum: !!(percussionChoice && percussionChoice[1] === 'max'), tempo: form.elements.gm_tempo.value, rest: '', collectionPath: form.getAttribute('action')};
    } else {
      var query = form.querySelector('input[name="q"]');
      if (!query) return;
      selection = interpretMusicQuery(query.value);
      if (!selection) return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    window.location.assign(buildMusicURL(selection, window.location.origin, preview).href);
  }, true);
}());
